<router-outlet></router-outlet>

<a href="https://wa.me/919063838822" target="_blank" rel="noopener" *ngIf="!isAdmin">
  <img src="../assets/images/social_15707820.png" alt="WhatsApp" class="whatsapp-icon">
</a>
